var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 12 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#212121",
    d: "M6 1.618 6.872 4.3l.112.346h3.183L7.887 6.304l-.294.213.112.346.872 2.682-2.282-1.658L6 7.674l-.294.213-2.282 1.658.872-2.682.112-.346-.294-.213-2.281-1.658h3.183l.112-.346z"
  })));
};
export default SvgStar;